/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Desktop_DescInputs */

const en_mk_nav_desktop_desc = /** @type {(inputs: Mk_Nav_Desktop_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Desktop for Linux or connect an agent through the CLI.`)
};

const id_mk_nav_desktop_desc = /** @type {(inputs: Mk_Nav_Desktop_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh Desktop Linux atau hubungkan agent melalui CLI.`)
};

/**
* | output |
* | --- |
* | "Download Desktop for Linux or connect an agent through the CLI." |
*
* @param {Mk_Nav_Desktop_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_desktop_desc = /** @type {((inputs?: Mk_Nav_Desktop_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Desktop_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_desktop_desc(inputs)
	return en_mk_nav_desktop_desc(inputs)
});